import type { TOC } from '@ember/component/template-only';
import { PhUser } from 'ember-phosphor-icons';
import { eq } from 'tio-ui/utilities';

interface AppHeaderInitialsIconSig {
  Args: {
    initials?: string;
    size?: 'sm' | 'md';
  };
  Element: HTMLDivElement;
}

const AppHeaderInitialsIconComponent: TOC<AppHeaderInitialsIconSig> = <template>
  <div
    class="tio-row-center tio-fg-inverse font-bold uppercase rounded-full tio-bg-success border-2 border-white shadow-md
      {{if (eq @size 'sm') 'text-xs h-7 w-7' 'text-sm h-10 w-10 p-1'}}"
    ...attributes
  >
    {{#if @initials}}
      {{@initials}}
    {{else}}
      <PhUser @size={{if (eq @size "sm") 16 24}} weight="fill" />
    {{/if}}
  </div>
</template>;

export default AppHeaderInitialsIconComponent;
